import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedButtonPrimeReact,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	RHookFormNumberFieldWithLabel,
	SingleColumnLayout,
	StandardPanel,
	TwoColumnLayout,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	federalClaimCodesInitialData,
	federalT3InitialData,
	provinsionalClaimCodesInitialData,
	provinsionalInitialData,
	provisionalVariableSInitialData,
	provisionalVariableV1InitialData,
	provisionalVariableV2InitialData,
} from "./globalVariablesconstants";
import {
	formatDate,
	formatDateToShow,
	scrollPanelFieldsToTop,
	useNavigateToLogout,
} from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { CPPSetupFieldsPanel } from "./Panels/CPPSetupFieldsPanel";
import { CSSTSetupFieldsPanel } from "./Panels/CSSTSetupFieldsPanel";
import { CountryService } from "../../services/common/CountryService";
import { DDLDataTable } from "../DDLDataTable";
import { DepartmentsSetupToolbar } from "../DepartmentsSetup/DepartmentsSetupToolbar";
import { EISetupFieldsPanel } from "./Panels/EISetupFieldsPanel";
import { EffectiveDateSetupFieldsPanel } from "./Panels/EffectiveDateSetupFieldsPanel";
import { FaderalLaborSponsoredFundsTaxCreditSetupFieldsPanel } from "./Panels/FaderalLaborSponsoredFundsTaxCreditSetupFieldsPanel";
import { FederalClaimCodesDataTable } from "./Panels/FederalClaimCodesDataTable";
import { FederalT3DataTable } from "./Panels/FederalT3DataTable";
import { GlobalVariablesHeader } from "./GlobalVariablesHeader";
import { GlobalVariablesService } from "../../services/GlobalVariablesService";
import { GlobalVariablesSetupToolbar } from "./GlobalVariablesSetupToolbar";
import { GlobalVariablesSetupValidationSchema } from "./validator";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { IGlobalVariables } from "../../models/GlobalVariables";
import { MiscSetupFieldsPanel } from "./Panels/MiscSetupFieldsPanel";
import { ProvinsionalClaimCodesDataTable } from "./Panels/ProvinsionalClaimCodesDataTable";
import { ProvinsionalDataTable } from "./Panels/ProvinsionalDataTable";
import { ProvisionalVariableForNonQCSetupSDataTables } from "./Panels/ProvisionalVariableForNonQCSetupSDataTables";
import { ProvisionalVariableForNonQCSetupV1DataTables } from "./Panels/ProvisionalVariableForNonQCSetupV1DataTables";
import { ProvisionalVariableForNonQCSetupV2DataTables } from "./Panels/ProvisionalVariableForNonQCSetupV2DataTables";
import { ProvisionalVariableForQCSetupFieldsPanel } from "./Panels/ProvisionalVariableForQCSetupFieldsPanel";
import { QHSFPrimaryAndManufacturingSetupFieldsPanel } from "./Panels/QHSFPrimaryAndManufacturingSetupFieldsPanel";
import { QHSFSetupFieldsPanel } from "./Panels/QHSFSetupFieldsPanel";
import { QPIPSetupFieldsPanel } from "./Panels/QPIPSetupFieldsPanel";
import { QPPSetupFieldsPanel } from "./Panels/QPPSetupFieldsPanel";
import { TD1FederalSetupFieldsPanel } from "./Panels/TD1FederalSetupFieldsPanel";
import { TD1ProvincialsSetupFieldsPanel } from "./Panels/TD1ProvincialsSetupFieldsPanel";
import { YearService } from "../../services/YearService";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IGlobalVariablesSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "globalVariables-single-data-record";
// const CHEQUE_SETTINGS_LIST_DATA_QUERY_KEY = "cheque-settings-list-data-record";

const useGetData = (
	// clientId: string,
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: () => {
			return GlobalVariablesService.getById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

//Tax Year DDL
const useYearDDL = () =>
	useQuery({
		queryKey: ["tax-tear-ddl"],
		queryFn: () => {
			return YearService.getTaxYearDDL();
		},
		refetchOnWindowFocus: false,
	});

const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});

// const useGlobalVariables = (
// 	clientId: string,
// 	params: IGetListRequest,
// 	navigateToLogout: (path: string) => void
// ) =>
// 	useQuery({
// 		queryKey: [CHEQUE_SETTINGS_LIST_DATA_QUERY_KEY, params],
// 		queryFn: (data) => {

// 			return GlobalVariablesService.getGlobalVariables(
// 				clientId,
// 				params,
// 				navigateToLogout
// 			);
// 		},
// 		refetchOnWindowFocus: false,
// 	});

export const GlobalVariables: React.FC<IGlobalVariablesSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	// const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [isPending, setIsPending] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [provinceDDLItems, setProvinceDDLItems] = useState([]);
	const [dateDDLItems, setDateDDLItems] = useState([]);
	const [selectedTaxYear, setSelectedTaxYear] = useState(null);
	const [selectedTaxYearLabel, setSelectedTaxYearLabel] = useState(null);
	const [selectedProvince, setSelectedProvince] = useState(null);
	const [selectedProvinceName, setSelectedProvinceName] = useState(null);
	const [selectedProvinceShortCode, setSelectedProvinceShortCode] =
		useState("AB");
	const [selectedDate, setSelectedDate] = useState<any>(undefined);
	const [globalVariablesId, setGlobalVariablesId] = useState<number>(0);
	const [federalT3Data, setFederalT3Data] = useState(federalT3InitialData);
	const [provinsionalData, setProvinsionalData] = useState(
		provinsionalInitialData
	);
	const [federalClaimCodesData, setFederalClaimCodesData] = useState(
		federalClaimCodesInitialData
	);
	const [provinsionalClaimCodesData, setProvinsionalClaimCodesData] = useState(
		provinsionalClaimCodesInitialData
	);
	const [provisionalVariableSData, setProvisionalVariableSData] = useState(
		provisionalVariableSInitialData
	);
	const [provisionalVariableV1Data, setProvisionalVariableV1Data] = useState(
		provisionalVariableV1InitialData
	);
	const [provisionalVariableV2Data, setProvisionalVariableV2Data] = useState(
		provisionalVariableV2InitialData
	);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	useEffect(() => {
		if (id) {
			setSelectedDate(id)
		}
	}, [id])

	const { isPending: isSubmitting, mutate: submitGlobalVariablesFormFields } =
		useMutation({
			mutationFn: GlobalVariablesService.create,
			onSuccess: (res: IGlobalVariables | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIGlobalVariablesResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					scrollPanelFieldsToTop();
					let path = `/global-variables/${res.data.id}`;
					navigate(path);
					setSelectedDate(res.data.id);
					return Promise.all([
						// queryClient.invalidateQueries({
						// 	queryKey: [CHEQUE_SETTINGS_LIST_DATA_QUERY_KEY],
						// }),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else if (res.status === 201) {
					// if (instanceOfIGlobalVariablesResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					scrollPanelFieldsToTop();
					let path = `/global-variables/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					setSelectedDate(res.data.id);
					return Promise.all([
						// queryClient.invalidateQueries({
						// 	queryKey: [CHEQUE_SETTINGS_LIST_DATA_QUERY_KEY],
						// }),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		// clientId,
		selectedDate,
		navigateToLogout
	);

	const { isPending: isPendingTaxYearDDL, data: taxYearDDL } = useYearDDL();

	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();

	useEffect(() => {
		if (countryList && Array.isArray(countryList)) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				(async () => {
					try {
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setProvinceDDLItems(response);
					} catch (err) {
						console.error("error", err);
					}
				})();
			}
		}
	}, [countryList]);

	// const [queryParams, setQueryParams] = useState<IGetListRequest>({
	// 	search_query: "",
	// 	order_by: "name",
	// 	order_direction: "asc",
	// 	page: 1,
	// 	size: 25,
	// });

	// const onRequestParamsChange = useCallback((requestParams: any) => {
	// 	let dispatchParams = {
	// 		search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
	// 		order_by:
	// 			requestParams.sortField !== null ? requestParams.sortField : "name",
	// 		order_direction: requestParams.sortOrder
	// 			? requestParams.sortOrder
	// 			: "asc",
	// 		page: requestParams.page + 1,
	// 		size: requestParams.rows,
	// 	};

	// 	setQueryParams(dispatchParams);
	// }, []);

	// const { isPending, data } = useGlobalVariables(
	// 	clientId,
	// 	queryParams,
	// 	navigateToLogout
	// );

	// const globalVariablesList: any | null = data;

	// const upadtedGlobalVariablesListItems = useMemo(() => {
	// 	return (
	// 		globalVariablesList &&
	// 		globalVariablesList.items &&
	// 		globalVariablesList?.items.map((item: any) => ({
	// 			...item,
	// 			label: (
	// 				<Link
	// 					to={`/global-variables/${item.id}`}
	// 					className="no-underline"
	// 					style={{ color: theme.palette.primary.light }}
	// 					onClick={() => setEditRecordId(item.id)}
	// 				>
	// 					{item.name}
	// 				</Link>
	// 			),
	// 		}))
	// 	);
	// }, [globalVariablesList]);

	const formMethods = useForm<any>({
		resolver: yupResolver(GlobalVariablesSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const onSubmit = (values: any) => {

		const seletedDate: any = dateDDLItems && dateDDLItems.find(
			(value: any) => value.value === values.date
		);
		const taxYearLabel: any = taxYearDDL && taxYearDDL.find(
			(value: any) => value.value === values.taxYear
		);


		let payload = {
			// clientId: clientId,
			id: selectedDate || undefined,
			navigateToLogout: navigateToLogout,
			province: values.province,
			provinceShortCode: selectedProvinceShortCode,
			// taxYear: values.taxYear,
			taxYear: taxYearLabel.label,
			date: values.date,
			dateLabel: seletedDate ? seletedDate.label : undefined,
			effectiveDate: formatDate(values.effectiveDate),
			...(selectedProvinceShortCode !== "QC" && {
				cpp: {
					annualMaxPensionableEarnings:
						values.annualMaxPensionableEarnings || undefined,
					basicExemptionForTheYear:
						values.basicExemptionForTheYear || undefined,
					employeeContributionRate:
						values.employeeContributionRate || undefined,
					employerContributionRate:
						values.employerContributionRate || undefined,
					employeeMaxContribution: values.employeeMaxContribution || undefined,
					annualSecondCppMaxPensionableEarnings:
						values.annualSecondCppMaxPensionableEarnings || undefined,
					secondCppContributionRate:
						values.secondCppContributionRate || undefined,
					secondCppMaxContribution:
						values.secondCppMaxContribution || undefined,
					cpp_qpp_k2_variable:
						values.cpp_qpp_k2_variable || undefined,
				},
			}),

			...(selectedProvinceShortCode === "QC" && {
				qpp: {
					annualMaxPensionableEarnings:
						values.annualMaxPensionableEarnings || undefined,
					basicExemptionForTheYear:
						values.basicExemptionForTheYear || undefined,
					employeeContributionRate:
						values.employeeContributionRate || undefined,
					employerContributionRate:
						values.employerContributionRate || undefined,
					employeeMaxContribution: values.employeeMaxContribution || undefined,
					annualSecondQppMaxPensionableEarnings:
						values.annualSecondQppMaxPensionableEarnings || undefined,
					secondQppContributionRate:
						values.secondQppContributionRate || undefined,
					secondQppMaxContribution:
						values.secondQppMaxContribution || undefined,
					cpp_qpp_k2_variable:
						values.cpp_qpp_k2_variable || undefined,
				},
				qpip: {
					maxInsurableAnnualEarnings:
						values.maxInsurableAnnualEarnings || undefined,
					maxAnnualPremium: values.maxAnnualPremium || undefined,
					premiumRate: values.premiumRate || undefined,
					employerContribution: values.employerContribution || undefined,
				},
				qhsf: {
					minimumQhsf: values.minimumQhsf || undefined,
					maximumQhsf: values.maximumQhsf || undefined,
					normalizeQhsf: values.normalizeQhsf || undefined,
					rate1Qhsf: values.rate1Qhsf || undefined,
					rate2Qhsf: values.rate2Qhsf || undefined,
				},
				qhsfPrimaryAndManufacturing: {
					minimumQhsfPrimaryManufacture: values.minimumQhsfPrimaryManufacture || undefined,
					maximumQhsfPrimaryManufacture: values.maximumQhsfPrimaryManufacture || undefined,
					normalizeQhsfPrimaryManufacture: values.normalizeQhsfPrimaryManufacture || undefined,
					rate1QhsfPrimaryManufacture: values.rate1QhsfPrimaryManufacture || undefined,
					rate2QhsfPrimaryManufacture: values.rate2QhsfPrimaryManufacture || undefined,
				},
				csst: {
					maximum: values.maximum || undefined,
				},
			}),

			ei: {
				maxInsurableAnnualEarningsEi:
					values.maxInsurableAnnualEarningsEi || undefined,
				maxAnnualPremiumEi: values.maxAnnualPremiumEi || undefined,
				premiumRateEi: values.premiumRateEi || undefined,
				employerContributionEi: values.employerContributionEi || undefined,
				employeeWhoHasEarnLessThenEi:
					values.employeeWhoHasEarnLessThenEi || undefined,
			},

			td1Federal: {
				basicPersonalAmountTd1Federal:
					values.basicPersonalAmountTd1Federal || undefined,
			},

			td1Provincials: {
				basicPersonalAmountTd1Provisionals:
					values.basicPersonalAmountTd1Provisionals || undefined,
			},

			misc: {
				maximumValueOfRrsp: values.maximumValueOfRrsp || undefined,
				cpiProvincial: values.cpiProvincial || undefined,
				cpiFederal: values.cpiFederal || undefined,
				deadToFileT4ForCurrentlySelectedYearOfOperation:
					formatDate(values.deadToFileT4ForCurrentlySelectedYearOfOperation) ||
					undefined,
				amountForFederalCanadaEmploymentCreditK4:
					values.amountForFederalCanadaEmploymentCreditK4 || undefined,
				amountForProvincialEmploymentCreditK4:
					values.amountForProvincialEmploymentCreditK4 || undefined,
			},

			federalLaborSponsoredFundsTaxCredit: {
				theFederalLaborSponsoredFundsTaxCreditIsTheLessorOf:
					values.theFederalLaborSponsoredFundsTaxCreditIsTheLessorOf ||
					undefined,
				andOfTheApprovedSharePurchaseFederal:
					values.andOfTheApprovedSharePurchaseFederal || undefined,
				theProvincialLaborSponsoredFundsTaxCreditIsTheLessorOf:
					values.theProvincialLaborSponsoredFundsTaxCreditIsTheLessorOf ||
					undefined,
				andOfTheApprovedSharePurchaseProvincial:
					values.andOfTheApprovedSharePurchaseProvincial || undefined,
			},

			federalT3: federalT3Data,
			provisional: provinsionalData,
			federalClaimCodes: federalClaimCodesData,
			yConstant: values.yConstant || undefined,

			...(selectedProvinceShortCode === "QC"
				? {
					quebecProvincialClaimCodes: provinsionalClaimCodesData,
					quebecProvincialVariable: {
						annualFederalTaxDeductionT1:
							values.annualFederalTaxDeductionT1 || undefined,
						deductionForEmploymentIncomeH:
							values.deductionForEmploymentIncomeH || undefined,
						deductionForEmploymentIncomeHMaximumOf:
							values.deductionForEmploymentIncomeHMaximumOf || undefined,
						quebecIncomeTaxForTheYearY1:
							values.quebecIncomeTaxForTheYearY1 || undefined,
						quebecIncomeTaxForTheYearY2:
							values.quebecIncomeTaxForTheYearY2 || undefined,
						quebecIncomeTaxForTheYearY3:
							values.quebecIncomeTaxForTheYearY3 || undefined,
					},
				}
				: {
					provisionalsClaimCodes: provinsionalClaimCodesData,
					provisionalVariable: {
						s: provisionalVariableSData,
						v1: provisionalVariableV1Data,
						v2: provisionalVariableV2Data,
					},
				}),

		};


		submitGlobalVariablesFormFields(payload);
	};

	useEffect(() => {
		if (selectedDate && selectedDataRecord && selectedDataRecord.id && taxYearDDL) {

			if (provinceDDLItems && provinceDDLItems.length > 0) {
				const savedProvince: any = provinceDDLItems && provinceDDLItems.find((x: any) => x.value === selectedDataRecord.province)
				setSelectedProvinceShortCode(savedProvince.shortCode)
			}
			const selectedYear: any = taxYearDDL.find((x: any) => x.label === Number(selectedDataRecord.taxYear))

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);

				if (fieldName === 'taxYear' && selectedYear) {
					// formMethods.setValue('taxYear', selectedYear.value);
					// setSelectedTaxYear(selectedYear.value)
					formMethods.setValue('taxYear', selectedYear.value);
					setSelectedTaxYear(selectedYear.value)
					setSelectedTaxYearLabel(selectedYear.label)
				}

				// if (typeof fieldValue === "object") {
				// 	Object.keys(fieldValue).forEach((objFieldName: any) => {
				// 		const objFieldValue = fieldValue[objFieldName];
				// 		formMethods.setValue(objFieldName, objFieldValue ?? undefined);
				// 	});
				// }
				if (
					fieldValue &&
					typeof fieldValue === "object" &&
					!Array.isArray(fieldValue)
				) {
					Object.keys(fieldValue).forEach((objFieldName: any) => {
						const objFieldValue = fieldValue[objFieldName];
						formMethods.setValue(objFieldName, objFieldValue ?? undefined);
					});
				}

				if (fieldName === "federalClaimCodes") {
					setFederalClaimCodesData(fieldValue);
				}
				if (fieldName === "federalT3") {
					setFederalT3Data(fieldValue);
				}
				if (fieldName === "provisional") {
					setProvinsionalData(fieldValue);
				}
				if (fieldName === "provisionalsClaimCodes") {
					setProvinsionalClaimCodesData(fieldValue);
				}
				if (fieldName === "quebecProvincialClaimCodes") {
					setProvinsionalClaimCodesData(fieldValue);
				}
				if (fieldName === "provisionalVariable" && fieldValue && fieldValue.s) {
					setProvisionalVariableSData(fieldValue.s);
					setProvisionalVariableV1Data(fieldValue.v1);
					setProvisionalVariableV2Data(fieldValue.v2);
				}
				if (fieldName === "effectiveDate") {

					formMethods.setValue(
						fieldName,
						formatDateToShow(fieldValue) ?? undefined
					);
				}
				if (fieldName === "misc") {
					Object.keys(fieldValue).forEach((objFieldName: any) => {
						const objFieldValue = fieldValue[objFieldName];
						if (
							objFieldName === "deadToFileT4ForCurrentlySelectedYearOfOperation" && objFieldValue !== null
						) {
							formMethods.setValue(
								objFieldName,
								new Date(objFieldValue) ?? undefined
							);
						}
					});
				}
				if (fieldName === "taxYear") {
					(async () => {
						try {
							setIsPending(true);
							const response = await GlobalVariablesService.getDateEffectiveDDL(
								fieldValue,
								selectedDataRecord.province
							);
							setDateDDLItems(response);
							const date = response.find(
								(value: any) => value.label === selectedDataRecord.effectiveDate
							);
							formMethods.setValue("date", date.value ?? undefined);
						} catch (err) {
							console.error("error", err);
						} finally {
							setIsPending(false);
						}
					})();
				}
				if (fieldName === "effectiveDate") {
					formMethods.setValue(fieldName, new Date(fieldValue) ?? undefined);
				}
			});
		}
	}, [selectedDate, selectedDataRecord, provinceDDLItems, taxYearDDL]);


	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteGlobalVariablesById } =
		useMutation({
			mutationFn: GlobalVariablesService.delGlobalVariables,
			onSuccess: (res: string | IServerError | IResponse) => {
				if (typeof res === "string") {
					// remove the cache of the GlobalVariables fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				formMethods.reset();
				scrollPanelFieldsToTop();
				let path = `/global-variables`;
				navigate(path);
				setDateDDLItems([])
				setFederalT3Data(federalT3InitialData)
				setProvinsionalData(provinsionalInitialData)
				setFederalClaimCodesData(federalClaimCodesInitialData)
				setProvinsionalClaimCodesData(provinsionalClaimCodesInitialData)
				setProvisionalVariableSData(provisionalVariableSInitialData)
				setProvisionalVariableV1Data(provisionalVariableV1InitialData)
				setProvisionalVariableV2Data(provisionalVariableV2InitialData)
				// formMethods.setValue('taxYear', undefined)
				// formMethods.setValue('province', undefined)
				setEditRecordId(undefined)
				setSelectedDate(undefined)
				// return Promise.all([
				// 	queryClient.invalidateQueries({
				// 		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
				// 	}),
				// ]);
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const deleteGlobalVariablesField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				globalVariablesId: globalVariablesId,
				navigateToLogout: navigateToLogout,
			};
			deleteGlobalVariablesById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setGlobalVariablesId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		scrollPanelFieldsToTop();
		let path = `/global-variables`;
		navigate(path);
	};

	const onYearSelectionChangeHandler = useCallback((params: any) => {
		if (params.value !== "") {
			let path = `/global-variables`;
			navigate(path);
			formMethods.reset();
			formMethods.setValue('date', undefined)
			formMethods.setValue('taxYear', params.value)
			formMethods.setValue('province', selectedProvince)
			setFederalT3Data(federalT3InitialData);
			setProvinsionalData(provinsionalInitialData);
			setFederalClaimCodesData(federalClaimCodesInitialData);
			setProvinsionalClaimCodesData(provinsionalClaimCodesInitialData);
			setProvisionalVariableSData(provisionalVariableSInitialData);
			setProvisionalVariableV1Data(provisionalVariableV1InitialData);
			setProvisionalVariableV2Data(provisionalVariableV2InitialData);
			setSelectedTaxYear(params.value);
			setSelectedTaxYearLabel(params.label)
			if (selectedProvince !== null) {
				(async () => {
					try {
						setIsPending(true);
						const response = await GlobalVariablesService.getDateEffectiveDDL(
							params.label,
							selectedProvince
						);
						setDateDDLItems(response);
					} catch (err) {
						console.error("error", err);
					} finally {
						setIsPending(false);
					}
				})();
			}
		} else {
			formMethods.reset()
		}

	}, [selectedProvince]);
	const onProvinceSelectionChangeHandler = useCallback((params: any) => {
		let path = `/global-variables`;
		navigate(path);
		formMethods.reset();
		formMethods.setValue('date', undefined)
		formMethods.setValue('taxYear', selectedTaxYear)
		formMethods.setValue('province', params.value)
		setFederalT3Data(federalT3InitialData);
		setProvinsionalData(provinsionalInitialData);
		setFederalClaimCodesData(federalClaimCodesInitialData);
		setProvinsionalClaimCodesData(provinsionalClaimCodesInitialData);
		setProvisionalVariableSData(provisionalVariableSInitialData);
		setProvisionalVariableV1Data(provisionalVariableV1InitialData);
		setProvisionalVariableV2Data(provisionalVariableV2InitialData);
		setSelectedProvince(params.value);
		setSelectedProvinceName(params.label);
		setSelectedProvinceShortCode(params.shortCode);

		const taxYearLabel: any = taxYearDDL && taxYearDDL.find(
			(value: any) => value.value === selectedTaxYear
		);
		if (taxYearLabel.label !== null && params.value !== "") {
			(async () => {
				try {
					setIsPending(true);
					const response = await GlobalVariablesService.getDateEffectiveDDL(
						taxYearLabel.label,
						params.value
					);
					setDateDDLItems(response);
				} catch (err) {
					console.error("error", err);
				} finally {
					setIsPending(false);
				}
			})();
		}
	}, [selectedTaxYear]);
	// const onDateSelectionChangeHandler = useCallback((params: any) => {
	// 	if (!params.value) {
	// 		formMethods.reset()
	// 		let path = `/global-variables/`
	// 		navigate(path)
	// 	} 
	// 		setSelectedDate(params.value);
	// 		let path = `/global-variables/${params.value}`
	// 		navigate(path)
	// }, []);

	const onDateSelectionChangeHandler = useCallback((params: any) => {
		if (!params?.value) {
			const getYearAndProvinceFieldValues = formMethods.getValues();
			formMethods.reset({
				taxYear: getYearAndProvinceFieldValues.taxYear,
				province: getYearAndProvinceFieldValues.province,

			});
			navigate(`/global-variables`);
			setSelectedDate(undefined);
			return;
		}
		setSelectedDate(params.value);
		navigate(`/global-variables/${params.value}`);
	}, []);


	const expandedLabels = ["Misc.", "Global Variables"];
	const expandedGlobalVariablesSetupOrSetupItem = "Global Variables"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Misc." &&
				item.label === expandedGlobalVariablesSetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedGlobalVariablesSetupOrSetupItem && "/global-variables",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		globalVariablesName: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);



	return (
		<Grid
		// sx={{ pb: "5rem", "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPending ||
					isPendingById ||
					isDeleting ||
					isPendingTaxYearDDL ||
					isPendingCountryDDL
				}
				testId="comapny Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteGlobalVariablesField}
				cancelActionHandler={onCloseHandler}
				testId="globalVariables-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<GlobalVariablesHeader
								yearList={taxYearDDL ?? []}
								provinceList={provinceDDLItems ?? []}
								dateList={dateDDLItems ?? []}
								onYearSelectionChangeHandler={onYearSelectionChangeHandler}
								onProvinceSelectionChangeHandler={
									onProvinceSelectionChangeHandler
								}
								onDateSelectionChangeHandler={onDateSelectionChangeHandler}
							/>
							<Grid
								size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
								sx={{
									// border: "1px solid rgba(0, 0, 0, 0.12)",
									// borderRadius: "3px",
									marginTop: "16px",
									// background: "#ffffff",
								}}
							>
								<TwoColumnLayout
									leftColumnContent={
										<>
											{selectedProvinceShortCode === "QC" ? (
												// {/* For QC */}
												<StandardPanel
													title="QPP"
													testId={`qpp`}
													variant="outlined"
													borderHide={true}
												>
													<QPPSetupFieldsPanel
														selectedTaxYear={selectedTaxYearLabel}
													/>
												</StandardPanel>
											) : (
												// {/* For Non QC */}
												<StandardPanel
													title="CPP"
													testId={`cpp`}
													variant="outlined"
													borderHide={true}
												>
													<CPPSetupFieldsPanel
														selectedTaxYear={selectedTaxYearLabel}
													/>
												</StandardPanel>
											)}
										</>
									}
									rightColumnContent={
										<>
											{/* For Both QC/Non QC */}
											<StandardPanel
												title="EI"
												testId={`ei`}
												variant="outlined"
												borderHide={true}
											>
												<EISetupFieldsPanel />
											</StandardPanel>
										</>
									}
									toolbar={<></>}
									showToolbar={false}
									testId="form-layout"
									toolbarPosition="bottom"
								/>
							</Grid>
							{/* Only For QC */}
							{selectedProvinceShortCode === "QC" && (
								<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
									<SingleColumnLayout
										children={
											<StandardPanel
												title="QPIP"
												testId={`qpip`}
												variant="outlined"
												topPadding={2}
											>
												<QPIPSetupFieldsPanel />
											</StandardPanel>
										}
										toolbar={<></>}
										testId="form-layout"
										showFullDiaplay={true}
										showToolbar={false}
									/>
								</Grid>
							)}
							{/* Same For both QC/Non QC */}
							<Grid
								size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
								sx={{
									// border: "1px solid rgba(0, 0, 0, 0.12)",
									// borderRadius: "3px",
									marginTop: "16px",
									// background: "#ffffff",
								}}
							>
								<TwoColumnLayout
									leftColumnContent={
										<>
											<StandardPanel
												title="TD1 Federal"
												testId={`TD1Federal`}
												variant="outlined"
												borderHide={true}
											>
												<TD1FederalSetupFieldsPanel />
											</StandardPanel>
										</>
									}
									rightColumnContent={
										<>
											<StandardPanel
												title="TD1 Provincials"
												testId={`TD1Provincials`}
												variant="outlined"
												borderHide={true}
											>
												<TD1ProvincialsSetupFieldsPanel />
											</StandardPanel>
										</>
									}
									toolbar={<></>}
									showToolbar={false}
									testId="form-layout"
									toolbarPosition="bottom"
								/>
							</Grid>
							{/* Same For both QC/Non QC */}
							<Grid
								size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
								sx={{
									// border: "1px solid rgba(0, 0, 0, 0.12)",
									// borderRadius: "3px",
									marginTop: "16px",
									// background: "#ffffff",
								}}
							>
								<TwoColumnLayout
									leftColumnContent={
										<>
											<StandardPanel
												title="Misc"
												testId={`Misc`}
												variant="outlined"
												borderHide={true}
											>
												<MiscSetupFieldsPanel
													selectedProvinceName={selectedProvinceName}
												/>
											</StandardPanel>
										</>
									}
									rightColumnContent={
										<>
											<StandardPanel
												title="Federal Labor Sponsored Funds Tax Credit"
												testId={`FaderalLaborSponsoredFundsTaxCredit`}
												variant="outlined"
												borderHide={true}
											>
												<FaderalLaborSponsoredFundsTaxCreditSetupFieldsPanel />
											</StandardPanel>
										</>
									}
									toolbar={<></>}
									showToolbar={false}
									testId="form-layout"
									toolbarPosition="bottom"
								/>
							</Grid>
							{/* Same for Both QC/ Non QC */}
							<Grid
								size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
								sx={{
									// border: "1px solid rgba(0, 0, 0, 0.12)",
									// borderRadius: "3px",
									marginTop: "16px",
									// background: "#ffffff",
								}}
							>
								<TwoColumnLayout
									leftColumnContent={
										<>
											<StandardPanel
												title="Federal (T3)"
												testId={`Federal-(T3)`}
												variant="outlined"
												borderHide={true}
											>
												<FederalT3DataTable
													federalT3Data={(data: any) => setFederalT3Data(data)}
													TableDataGetById={id && selectedDataRecord ? selectedDataRecord.federalT3 : undefined}
												/>
											</StandardPanel>
										</>
									}
									rightColumnContent={
										<>
											<StandardPanel
												title="Provinsional"
												testId={`Provinsional`}
												variant="outlined"
												borderHide={true}
											>
												<ProvinsionalDataTable
													provinsionalData={(data: any) =>
														setProvinsionalData(data)
													}
													TableDataGetById={id && selectedDataRecord ? selectedDataRecord.provisional : undefined}
												/>
											</StandardPanel>
										</>
									}
									toolbar={<></>}
									showToolbar={false}
									testId="form-layout"
									toolbarPosition="bottom"
								/>
							</Grid>
							{/* Same for both QC/ Non QC but have Different Header Columns for Provincial Claim Codes */}
							<Grid
								size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
								sx={{
									// border: "1px solid rgba(0, 0, 0, 0.12)",
									// borderRadius: "3px",
									marginTop: "16px",
									// background: "#ffffff",
								}}
							>
								<TwoColumnLayout
									leftColumnContent={
										<>
											<StandardPanel
												title="Federal Claim Codes"
												testId={`Federal-Claim-Codes`}
												variant="outlined"
												borderHide={true}
											>
												<FederalClaimCodesDataTable
													federalClaimCodesData={(data: any) =>
														setFederalClaimCodesData(data)
													}
													TableDataGetById={
														id && selectedDataRecord ? selectedDataRecord.federalClaimCodes : undefined
													}
												/>
											</StandardPanel>
										</>
									}
									rightColumnContent={
										<>
											<StandardPanel
												title="Provinsional Claim Codes"
												testId={`Provinsional-Claim-Codes`}
												variant="outlined"
												borderHide={true}
											>
												<ProvinsionalClaimCodesDataTable
													provinsionalClaimCodesData={(data: any) =>
														setProvinsionalClaimCodesData(data)
													}
													provinceShortCode={selectedProvinceShortCode}
													TableDataGetById={
														id && selectedDataRecord ? selectedDataRecord.provisionalsClaimCodes : undefined
													}
												/>
											</StandardPanel>
										</>
									}
									toolbar={<></>}
									showToolbar={false}
									testId="form-layout"
									toolbarPosition="bottom"
								/>
							</Grid>
							{/* different for both */}
							<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
								<SingleColumnLayout
									children={
										<StandardPanel
											title="Provisional Variable"
											testId={`Provisional-Variable`}
											variant="outlined"
											topPadding={2}
										>
											{selectedProvinceShortCode === "QC" ? (
												<ProvisionalVariableForQCSetupFieldsPanel />
											) : (
												<>
													<ProvisionalVariableForNonQCSetupSDataTables
														provisionalVariableSData={(data: any) =>
															setProvisionalVariableSData(data)
														}
														TableDataGetById={
															id && selectedDataRecord ? selectedDataRecord.provisionalVariable.s : undefined
														}
													/>
													<ProvisionalVariableForNonQCSetupV1DataTables
														provisionalVariableV1Data={(data: any) =>
															setProvisionalVariableV1Data(data)
														}
														TableDataGetById={
															id && selectedDataRecord ? selectedDataRecord.provisionalVariable.v1 : undefined
														}
													/>
													<ProvisionalVariableForNonQCSetupV2DataTables
														provisionalVariableV2Data={(data: any) =>
															setProvisionalVariableV2Data(data)
														}
														TableDataGetById={
															id && selectedDataRecord ? selectedDataRecord.provisionalVariable.v2 : undefined
														}
													/>
													<Grid size={{ xs: 6, sm: 6, md: 4.75, lg: 4.75, xl: 4.75 }} sx={{ mt: 3 }}>
														<RHookFormNumberFieldWithLabel id={"yConstant"} testId={"yrate"} label={"Y Rate"}
															maxFractionDigits={10} />
													</Grid>
												</>
											)}
										</StandardPanel>
									}
									toolbar={<></>}
									testId="form-layout"
									showFullDiaplay={true}
									showToolbar={false}
								/>
							</Grid>
							{/* only for QC */}
							{selectedProvinceShortCode === "QC" && (
								<Grid
									size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
									sx={{
										// border: "1px solid rgba(0, 0, 0, 0.12)",
										// borderRadius: "3px",
										marginTop: "16px",
									}}
								>
									<TwoColumnLayout
										leftColumnContent={
											<>
												<StandardPanel
													title="QHSF"
													testId={`QHSF`}
													variant="outlined"
													borderHide={true}
												>
													<QHSFSetupFieldsPanel />
												</StandardPanel>
											</>
										}
										rightColumnContent={
											<>
												<StandardPanel
													title="QHSF Primary and Manufacturing"
													testId={`QHSF-Primary-and-Manufacturing`}
													variant="outlined"
													borderHide={true}
												>
													<QHSFPrimaryAndManufacturingSetupFieldsPanel />
												</StandardPanel>
											</>
										}
										toolbar={<></>}
										showToolbar={false}
										testId="form-layout"
										toolbarPosition="bottom"
									/>
								</Grid>
							)}
							{/* only for QC */}
							{selectedProvinceShortCode === "QC" && (
								<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
									<SingleColumnLayout
										children={
											<StandardPanel
												title="CSST"
												testId={`csst`}
												variant="outlined"
												topPadding={2}
											>
												<CSSTSetupFieldsPanel />
											</StandardPanel>
										}
										toolbar={<></>}
										testId="form-layout"
										showFullDiaplay={true}
										showToolbar={false}
									/>
								</Grid>
							)}
							{/* For Both */}
							<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ position: "sticky", bottom: 65, zIndex: 2, "& .calenderWrapper": { maxWidth: "296px!important", marginBottom: "0!important" }, "& .MuiCardContent-root": { padding: "8px 24px" } }}>
								<SingleColumnLayout
									children={
										<StandardPanel
											title="Effective Date"
											testId={`Effective Date`}
											variant="outlined"
											showTitle={false}
											// borderHide={true}
											topPadding={2}
										>
											<EffectiveDateSetupFieldsPanel />
										</StandardPanel>
									}
									toolbar={<></>}
									testId="form-layout"
									showFullDiaplay={true}
									showToolbar={false}
								/>
							</Grid>

							<GlobalVariablesSetupToolbar
								onDeleteClicked={onDeleteClicked}
								isSubmitting={false}
								id={id}
							/>
						</Grid>
					</Grid>
				</form>
			</FormProvider>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"globalVariables-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
